import { SOLO_REPORTS } from "../actions";
import { merge } from "lodash/object";

const initialState = {
  items: []
};

const soloReports = (state = initialState, action) => {
  switch (action.type) {
    case SOLO_REPORTS["REQUEST"]:
      return initialState;
    case SOLO_REPORTS["SUCCESS"]:
      return merge({}, state, { items: action.response });
    default:
      return initialState;
  }
};

export default soloReports;
